import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./motion";
import { CITIES } from "@/data/cities";
import { countByCity } from "@/data/projects";

export default function CityGrid({ limit }) {
    const cities = limit ? CITIES.slice(0, limit) : CITIES;
    return (
        <div
            data-testid="city-grid"
            className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4"
        >
            {cities.map((city, i) => {
                const count = countByCity(city.slug);
                return (
                    <Reveal key={city.slug} delay={(i % 4) * 0.08}>
                        <Link
                            to={`/city/${city.slug}`}
                            data-testid={`city-card-${city.slug}`}
                            className="group relative block h-72 overflow-hidden rounded-2xl"
                        >
                            <img
                                src={city.image}
                                alt={`${city.name} cityscape`}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/60 to-transparent" />
                            <div className="absolute inset-x-0 bottom-0 p-5">
                                <p className="inline-block rounded-full bg-obsidian/70 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.25em] text-gold backdrop-blur">
                                    {count > 0
                                        ? `${count} project${count > 1 ? "s" : ""}`
                                        : "Onboarding developers"}
                                </p>
                                <div className="mt-1.5 flex items-end justify-between">
                                    <div>
                                        <h3 className="font-serif text-2xl text-ivory">
                                            {city.name}
                                        </h3>
                                        <p className="text-xs text-mist">{city.state}</p>
                                    </div>
                                    <span className="flex h-9 w-9 items-center justify-center rounded-full border border-black/20 text-ivory transition-all duration-300 group-hover:border-gold group-hover:bg-gold group-hover:text-obsidian">
                                        <ArrowUpRight className="h-4 w-4" />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </Reveal>
                );
            })}
        </div>
    );
}
